<app-confirmation-dialog [props]="props" id="notify-plan-dialog">
  <div class="modal-content-container" id="notify-plan-content">
    @if (notificationType === 'PLAN_CHANGED') {
      <div id="notify-plan-changed-wrapper">
        <p class="mb-3" i18n="@@notifyPlanChangeText1" id="notify-plan-changed-p1">
        Ha habido un cambio en su plan de gestión de cartera.
      </p>
        <p class="mb-1" i18n="@@notifyPlanChangeText2" id="notify-plan-changed-p2">
        Los atributos que se monitorean pueden cambiar.
      </p>
      </div>
    }

    @if (notificationType === 'NEW_PLAN_AVAILABLE') {
      <div id="notify-plan-new-wrapper">
        <p class="mb-3" i18n="@@notifyPlanCreateText1" id="notify-plan-new-p1">
        Se ha puesto a disposición un nuevo plan para su uso en Gestión de carteras
      </p>
        <p class="mb-1" i18n="@@notifyPlanCreateText2" id="notify-plan-new-p2">
        Nuevos atributos están disponibles para su seguimiento.
      </p>
      </div>
    }

    <mat-checkbox class="black-checkbox" [(ngModel)]="showAgain" id="notify-plan-checkbox-showagain">
      <span i18n="@@notifyPlanTextCheckbox">
        Mostrar de nuevo en el próximo inicio de sesión
      </span>
    </mat-checkbox>
  </div>
</app-confirmation-dialog>
